import $fetch from '@/utils/fetch'
import queryString from '@/utils/queryString'
import { defineStore } from "pinia";
import { ApiHome } from '@/api/home'
import { ApiModel } from '@/api/model';
const fetchQuery = (params: any) => {
  return ApiHome.apiGetMainList(params).then(data => data.data || { total: 0, list: [] })
}

const fetchCompute = () => {
  return ApiHome.apiGetActiveList().then(data => data.data || { total: 0, list: [] })
}

export default defineStore('homeStore', {
  state: () => ({
    query: {
      tagId: 0,
      type: null,
      sortType: 1,
      page: 1,
      pageSize: 10,
      keywords: ''
    },
    loading: true,
    loaded: false,
    total: 0,
    // barWidth: 84,
    barWidth: 237,
    list: [] as any[],
    powerNumInfo: {
      generateSong: 0, //创作歌曲
      generatePainting: 0, //生成创意画作
      generatePoster: 0, //海报画面生成
      generateAudio: 0, //生成音频
      generateTimingAudio: 0, //AI音效
      haimianGenerateBgm: 0, //海绵音乐-生成纯音乐
      haimianGenerateMusic: 0, //海绵音乐-词曲定制
      generateVideo: 0, //生成视频
      zChat: 0, // zChat
      generateVideoLuma: 0, //Luma.生成视频
      generateVideoZhiPu: 0, //智谱清影AI.生成视频
      generateVideoKeLing: 0, //快手可灵AI.生成视频
      aiVideoLiteGenerate: 0, //AI短片-生成视频
      generatePicture: 0, //Midjourney.开始生图
      generateVideoRunway: 0, //Runway.生成视频
      generateVideoMinimax: 0, //海螺.生成视频
      generateVideoVidu: 0, //Vidu.生成视频
      generateVideoTongyi: 0, //通义生成视频
      generateVideo302OpenAi: 0, //sora生成视频
      generateVideoJimeng: 0, //即梦生成视频
      generateVideo302KeLing: 0, //多图参考
      aiWritingOutline: 0, //AI写稿.大纲
      aiWritingExcerpt: 0, //AI写稿.摘编
      aiWritingArticles: 0, //AI写稿.文章
      aiVideoScreenwritingGenerate: 0, //AI短片-创作剧本
      aiVideoCharacterHistoryGenerate: 0, //AI短片-生成AI角色
      aiVideoStoryboardGenerate: 0, //AI短片-创作分镜
      indexTtsGenerate: 0, //AI声音实验室-情感克隆
      generatePodcast: 0, //AI播客
      digitalVideoFaceSwap: 0, //AI数字人-视频换脸
      digitalVideoMenSwap: 0, //AI数字人-视频换人
      digitalDanceTongyi: 0, //AI数字人-动作迁移通义
      digitalDanceJimeng: 0, //AI数字人-动作迁移即梦
      digitalVideoTongyiByDuration: 0, //AI数字人-高清播报通义-秒数
      digitalVideoTongyiByWord: 0, //AI数字人-高清播报通义-字数
      digitalVideoJimengByDuration: 0, //AI数字人-高清播报即梦-秒数
      digitalVideoJimengByWord: 0, //AI数字人-高清播报即梦-字数
      videoAdRecognition: 0, //视频广告识别
      superResolution: 0, //超分辨率
      multimodalCeation: 0, //全能参考
      asrVoice: 0, //音视频识别
      aiManjuRegenAsset: 0, //短剧AI-重新生成资产
      seedance2_0_480p: 0, //seedance2.0-480p
      seedance2_0_720p: 0, //seedance2.0-720p
      seedance2_0_1080p: 0, //seedance2.0-1080p
      seedance2_0_4k: 0, //seedance2.0-4k
      seedance2_0_FAST_480p: 0, //seedance2.0-FAST-480p
      seedance2_0_FAST_720p: 0, //seedance2.0-FAST-720p
      happyhorse1_1_720p: 0, //happyhorse1.1-720p
      happyhorse1_1_1080p: 0, //happyhorse1.1-1080p
      keling_720p: 0, //keling-720p
      keling_1080p: 0, //keling-1080p
      keling_4k: 0, //keling-4k
      generatePreVoice: 0, // AI配音-预置
      generateCloneVoice: 0, // AI配音-克隆
      separationVoice: 0, // AI配音-分离
    },
    zmgPowerNumInfo: {
      generateSong: 0, //创作歌曲
      generatePainting: 0, //生成创意画作
      generatePoster: 0, //海报画面生成
      generateAudio: 0, //生成音频
      generateTimingAudio: 0, // AI音效
      haimianGenerateBgm: 0, //海绵音乐-生成纯音乐
      haimianGenerateMusic: 0, //海绵音乐-词曲定制
      generateVideo: 0, //生成视频
      zChat: 0, // zChat
      generateVideoLuma: 0, //Luma.生成视频
      generateVideoZhiPu: 0, //智谱清影AI.生成视频
      generateVideoKeLing: 0, //快手可灵AI.生成视频
      aiVideoLiteGenerate: 0, //AI短片-生成视频
      generatePicture: 0, //Midjourney.开始生图
      generateVideoRunway: 0, //Runway.生成视频
      generateVideoMinimax: 0, //海螺.生成视频
      generateVideoVidu: 0, //Vidu.生成视频
      generateVideoTongyi: 0, //通义生成视频
      generateVideo302OpenAi: 0, //sora生成视频
      generateVideoJimeng: 0, //即梦生成视频
      generateVideo302KeLing: 0, //多图参考
      aiWritingOutline: 0, //AI写稿.大纲
      aiWritingExcerpt: 0, //AI写稿.摘编
      aiWritingArticles: 0, //AI写稿.文章
      aiVideoScreenwritingGenerate: 0, //AI短片-创作剧本
      aiVideoCharacterHistoryGenerate: 0, //AI短片-生成AI角色
      aiVideoStoryboardGenerate: 0, //AI短片-创作分镜
      indexTtsGenerate: 0, //AI声音实验室-情感克隆
      generatePodcast: 0, //AI播客
      digitalVideoFaceSwap: 0, //AI数字人-视频换脸
      digitalVideoMenSwap: 0, //AI数字人-视频换人
      digitalDanceTongyi: 0, //AI数字人-动作迁移通义
      digitalDanceJimeng: 0, //AI数字人-动作迁移即梦
      digitalVideoTongyiByDuration: 0, //AI数字人-高清播报通义-秒数
      digitalVideoTongyiByWord: 0, //AI数字人-高清播报通义-字数
      digitalVideoJimengByDuration: 0, //AI数字人-高清播报即梦-秒数
      digitalVideoJimengByWord: 0, //AI数字人-高清播报即梦-字数
      videoAdRecognition: 0, //视频广告识别
      superResolution: 0, //超分辨率
      multimodalCeation: 0, //全能参考
      asrVoice: 0, //音视频识别
      aiManjuRegenAsset: 0, //短剧AI-重新生成资产
      seedance2_0_480p: 0, //seedance2.0-480p
      seedance2_0_720p: 0, //seedance2.0-720p
      seedance2_0_1080p: 0, //seedance2.0-1080p
      seedance2_0_4k: 0, //seedance2.0-4k
      seedance2_0_FAST_480p: 0, //seedance2.0-FAST-480p
      seedance2_0_FAST_720p: 0, //seedance2.0-FAST-720p
      happyhorse1_1_720p: 0, //happyhorse1.1-720p
      happyhorse1_1_1080p: 0, //happyhorse1.1-1080p
      keling_720p: 0, //keling-720p
      keling_1080p: 0, //keling-1080p
      keling_4k: 0, //keling-4k
      generatePreVoice: 0, // AI配音-预置
      generateCloneVoice: 0, // AI配音-克隆
      separationVoice: 0, // AI配音-分离
    },
    powerBalance: 0, //算力值
    extraPowerBalance: 0, // 额外智媒豆，后端返回第二余额字段时透传
    dialogValue: 0, //打开弹窗个数，当有弹窗打开时需禁止底部页面滚动
    powerType: 1, // 指定算力类型，默认1 ，1=智媒豆  2=智媒果
    selectedTabName: '',
  }),
  getters: {
    hasMore: state => {
      return state.list.length < state.total
    },
    getSelectedTabName: (state) => state.selectedTabName,

  },
  actions: {
    setSelectedTabName(value: string) {
      this.selectedTabName = value;
    },
    handleBarChange(barWidthVal: any) {
      this.barWidth = barWidthVal; //导航栏宽度
    },
    // 更新全局支付方式
    updatePowerType(powerType: number) {
      return ApiHome.apiPostAccountUpdate({ powerType }).then((res: any) => {
        if (res?.code === 200) {
          this.powerType = res.data?.powerType || powerType;
          return this.loadPower(localStorage.getItem("AI-UserId"));
        }
        return res;
      });
    },
    loadQuery() {
      this.loading = true
      this.loaded = false
      this.query.page = 1
      if (this.query.keywords === 'undefined') this.query.keywords = ''
      return fetchQuery(this.query)
        .then(data => {
          this.total = 0
          this.list = data.map((item: any) => {
            return {
              ...item,
              cover: item.cover + '?x-oss-process=image/resize,m_mfit,h_500,w_300',
              width: item.width || 500,
              height: item.height || 500
            }
          }) || []
        })
        .finally(() => {
          this.loading = false
          this.loaded = true
        })
    },
    loadMore() {
      if (this.loading) return Promise.resolve(false)
      this.query.page++
      this.loading = true
      this.loaded = false
      if (this.query.keywords === 'undefined') this.query.keywords = ''

      return fetchQuery(this.query)
        .then(data => {
          this.total = data.total || 0
          this.list = [...this.list, ...data.list.map((item: any) => {
            return {
              ...item,
              cover: item.cover + '?x-oss-process=image/resize,m_mfit,h_500,w_300',
              width: item.width || 500,
              height: item.height || 500
            }
          })]
        })
        .finally(() => {
          this.loading = false
          this.loaded = true
          return true
        })
    },
    loadPower(val: any) {
      let params = {
        userId: val,
      };
      return ApiHome.apiGetComputilityAccount(params).then((res: any) => {
        if (res?.code == 200) {
          const accountData = res.data || {};
          this.powerBalance = accountData.powerBalance || 0;
          this.extraPowerBalance = accountData.zmgPowerBalance || 0;
          this.powerType = accountData.powerType || 1;
          localStorage.setItem('accountType', res.data.accountType);
        }
        return res;
      })
    },
    loadCompute() {
      return fetchCompute()
        .then(data => {
          const powerList = data.list;
          if (powerList && powerList.length > 0) {

            powerList?.map((item: any) => {
              // 生成创意画作

              if (item.taskKey == "generateCreativePainting") {
                this.powerNumInfo.generatePainting = item.taskNum;
                this.zmgPowerNumInfo.generatePainting = item.zmgTaskNum;
              }
              else if (item.taskKey == "generateVideo302KeLing") {
                this.powerNumInfo.generateVideo302KeLing = item.taskNum;
              }
              // suno.创作歌曲
              else if (item.taskKey == "generateSong") {
                this.powerNumInfo.generateSong = item.taskNum;
              }
              // AI海报生成.海报画面生成
              else if (item.taskKey == "generatePoster") {
                this.powerNumInfo.generatePoster = item.taskNum;
              }
              // AI声音实验室.生成音频
              else if (item.taskKey == "generateAudio") {
                this.powerNumInfo.generateAudio = item.taskNum;
              }
              // AI音效
              else if (item.taskKey == "generateTimingAudio") {
                this.powerNumInfo.generateTimingAudio = item.taskNum;
              }
              // 海绵音乐-生成纯音乐
              else if (item.taskKey == "haimianGenerateBgm") {
                this.powerNumInfo.haimianGenerateBgm = item.taskNum;
              }
              // 海绵音乐-词曲定制
              else if (item.taskKey == "haimianGenerateMusic") {
                this.powerNumInfo.haimianGenerateMusic = item.taskNum;
              }
              // AI数字人.生成视频
              else if (item.taskKey == "generateVideo") {
                this.powerNumInfo.generateVideo = item.taskNum;
              }
              // zChat
              else if (item.taskKey == "zChat") {
                this.powerNumInfo.zChat = item.taskNum;
              }
              // Luma.生成视频
              else if (item.taskKey == "generateVideoLuma") {
                this.powerNumInfo.generateVideoLuma = item.taskNum;
              }
              // 智谱清影AI.生成视频
              else if (item.taskKey == "generateVideoZhiPu") {
                this.powerNumInfo.generateVideoZhiPu = item.taskNum;
              }
              // 快手可灵AI.生成视频
              else if (item.taskKey == "generateVideoKeLing") {
                this.powerNumInfo.generateVideoKeLing = item.taskNum;
              }
              else if (item.taskKey == "aiVideoLiteGenerate") {
                this.powerNumInfo.aiVideoLiteGenerate = item.taskNum;
              }
              // Runway.生成视频
              else if (item.taskKey == "generateVideoRunway") {
                this.powerNumInfo.generateVideoRunway = item.taskNum;
              }
              // 海螺.生成视频
              else if (item.taskKey == "generateVideoMinimax") {
                this.powerNumInfo.generateVideoMinimax = item.taskNum;
              }
              // Vidu.生成视频
              else if (item.taskKey == "generateVideoVidu") {
                this.powerNumInfo.generateVideoVidu = item.taskNum;
              }
              // 通义万相
              else if (item.taskKey == "generateVideoTongyi") {
                this.powerNumInfo.generateVideoTongyi = item.taskNum;
              }

              // 即梦
              else if (item.taskKey == "generateVideoJimeng") {
                this.powerNumInfo.generateVideoJimeng = item.taskNum;
              }
              // AI写稿.大纲
              else if (item.taskKey == "aiWritingOutline") {
                this.powerNumInfo.aiWritingOutline = item.taskNum;
              }
              // AI写稿.摘编
              else if (item.taskKey == "aiWritingExcerpt") {
                this.powerNumInfo.aiWritingExcerpt = item.taskNum;
              }

              // AI写稿.文章
              else if (item.taskKey == "aiWritingArticles") {
                this.powerNumInfo.aiWritingArticles = item.taskNum;
              }

              // AI配音-预置
              else if (item.taskKey == "generatePreVoice") {
                this.powerNumInfo.generatePreVoice = item.taskNum;
              }

              // AI配音-克隆
              else if (item.taskKey == "generateCloneVoice") {
                this.powerNumInfo.generateCloneVoice = item.taskNum;
              }

              // AI配音-分离
              else if (item.taskKey == "separationVoice") {
                this.powerNumInfo.separationVoice = item.taskNum;
              }
              // AI短片-创作剧本
              else if (item.taskKey == "aiVideoScreenwritingGenerate") {
                this.powerNumInfo.aiVideoScreenwritingGenerate = item.taskNum;
              }
              else if (item.taskKey == "aiVideoCharacterHistoryGenerate") {
                this.powerNumInfo.aiVideoCharacterHistoryGenerate = item.taskNum;
              }
              else if (item.taskKey == "aiVideoStoryboardGenerate") {
                this.powerNumInfo.aiVideoStoryboardGenerate = item.taskNum;
              }
              // AI配音-情感克隆
              else if (item.taskKey == "indexTtsGenerate") {
                this.powerNumInfo.indexTtsGenerate = item.taskNum;
              }
              // AI配音-情感克隆
              else if (item.taskKey == "generatePodcast") {
                this.powerNumInfo.generatePodcast = item.taskNum;
              }
              else if (item.taskKey == "generateVideo302OpenAi") {
                this.powerNumInfo.generateVideo302OpenAi = item.taskNum;
              }
              // AI数字人-视频换脸
              else if (item.taskKey == "digitalVideoFaceSwap") {
                this.powerNumInfo.digitalVideoFaceSwap = item.taskNum;
              }
              // AI数字人-视频换人
              else if (item.taskKey == "digitalVideoMenSwap") {
                this.powerNumInfo.digitalVideoMenSwap = item.taskNum;
              }
              // AI数字人-动作迁移通义
              else if (item.taskKey == "digitalDanceTongyi") {
                this.powerNumInfo.digitalDanceTongyi = item.taskNum;
              }
              // AI数字人-动作迁移即梦
              else if (item.taskKey == "digitalDanceJimeng") {
                this.powerNumInfo.digitalDanceJimeng = item.taskNum;
              }
              // AI数字人-高清播报通义-秒数
              else if (item.taskKey == "digitalVideoTongyiByDuration") {
                this.powerNumInfo.digitalVideoTongyiByDuration = item.taskNum;
              }
              // AI数字人-高清播报通义-字数
              else if (item.taskKey == "digitalVideoTongyiByWord") {
                this.powerNumInfo.digitalVideoTongyiByWord = item.taskNum;
              }
              // AI数字人-高清播报即梦-秒数
              else if (item.taskKey == "digitalVideoJimengByDuration") {
                this.powerNumInfo.digitalVideoJimengByDuration = item.taskNum;
              }
              // AI数字人-高清播报即梦-字数
              else if (item.taskKey == "digitalVideoJimengByWord") {
                this.powerNumInfo.digitalVideoJimengByWord = item.taskNum;
              }
              // 视频广告识别
              else if (item.taskKey == "videoAdRecognition") {
                this.powerNumInfo.videoAdRecognition = item.taskNum;
              }
              // 超分辨率
              else if (item.taskKey == "superResolution") {
                this.powerNumInfo.superResolution = item.taskNum;
              }
              // 全能参考
              else if (item.taskKey == "multimodalCeation") {
                this.powerNumInfo.multimodalCeation = item.taskNum;
              }
              // 音视频识别
              else if (item.taskKey == "asrVoice") {
                this.powerNumInfo.asrVoice = item.taskNum;
              }
              else {
                // 简化写法
                this.powerNumInfo[item.taskKey] = item.taskNum;
              }
              this.zmgPowerNumInfo[item.taskKey] = item.zmgTaskNum;
            })
          }
        })
    },
  }
})
